export default "__VITE_ASSET__C7Hd2XM___"